import React from 'react';

const TabNav = ({ activeTab, onTabChange }) => {
  // Short labels on phones so all four tabs stay reachable without scrolling
  const tabs = [
    { id: 'profile', label: 'Player Profile', short: 'Profile' },
    { id: 'fit', label: 'Fit Analysis', short: 'Fit' },
    { id: 'grading', label: 'Grading', short: 'Grading' },
    { id: 'game-stats', label: 'Game Stats', short: 'Stats' },
    { id: 'recruiting', label: 'Recruiting Page', short: 'Page' }
  ];

  return (
    <div className="chip-row md:flex md:gap-8 border-b border-[#546E7A]/30 mb-5 md:mb-6 app-chrome">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          aria-current={activeTab === tab.id ? 'page' : undefined}
          className={`flex-1 md:flex-none whitespace-nowrap text-sm md:text-base ${
            activeTab === tab.id ? 'tab-active' : 'tab-inactive'
          }`}
        >
          <span className="md:hidden">{tab.short}</span>
          <span className="hidden md:inline">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNav;
